import en from './en'
import cn from './cn'
// import ko from './ko';
export default {
  en: en,
  cn: cn
  // ko: ko
}
